var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3682 15.0219C29.3682 14.0231 29.2862 13.0206 29.1085 12.039H14.98V17.6929H23.071C22.7353 19.5163 21.6558 21.1293 20.0766 22.1548V25.8227H24.9039C27.7382 23.2646 29.3682 19.4896 29.3682 15.0219Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9796 29.3686C19.0202 29.3686 22.4265 28.0675 24.9094 25.8231L20.0821 22.1553C18.7391 23.0507 17.0058 23.5578 14.9854 23.5578C11.0775 23.5578 7.76304 20.9728 6.57427 17.4982H1.59277V21.2809C4.13623 26.2383 9.31488 29.3686 14.9796 29.3686Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56848 17.4976C5.94188 15.6741 5.94188 13.6996 6.56848 11.8762V8.09351H1.59283C-0.530944 12.2416 -0.530944 17.1302 1.59283 21.2802L6.56848 17.4976Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9796 5.81158C17.1151 5.77905 19.1803 6.56735 20.7263 8.01192L25.0031 3.8198C22.2957 1.32863 18.7001 -0.0413192 14.9796 0.000774232C9.31488 0.000774232 4.13623 3.13099 1.59277 8.09419L6.56842 11.8769C7.75133 8.3965 11.0717 5.81349 14.9796 5.81349V5.81158Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.551dff1eced81be118fea46a3d2c1706.svg";
export { ForwardRef as ReactComponent };